import { LOCATION_META } from '../../constants';
import { DateNav } from '../DateNav/DateNav';
import s from '../../styles/dashboard.module.css';

// Summary bar under the header: date nav, totals, per-location toggles, live tag.
export function StatsBar({ selectedDate, onChangeDate, allApptsCount, totalDone, byLocation, activeLocations, toggleLocation, isToday }) {
  return (
    <div className={s.statsBar} style={{ flexShrink: 0 }}>
      <DateNav selectedDate={selectedDate} onChange={onChangeDate} />
      <div className={s.statsBarDivider} />
      <div className={s.statPill}><span className={s.statLabel}>Total</span><span className={s.statValue}>{allApptsCount}</span></div>
      <div className={s.statPill}><span className={s.statLabel}>Done</span><span className={`${s.statValue} ${s.green}`}>{totalDone}</span></div>
      {Object.entries(LOCATION_META).map(([locId, meta]) => {
        const appts = byLocation[locId]?.appointments || [];
        const isActive = activeLocations.includes(locId);
        return (
          <button key={locId} onClick={() => toggleLocation(locId)}
            className={`${s.statPill} ${s.localPill} ${isActive ? s.active : ''}`}>
            <span className={s.statLabel} style={{ color: isActive ? meta.color : undefined }}>{meta.name}</span>
            <span className={s.statValue} style={{ color: isActive ? meta.color : undefined }}>{appts.length}</span>
          </button>
        );
      })}
      <span className={s.liveTag}>{isToday ? '● LIVE FROM SQUARE' : '○ HISTORICAL VIEW'}</span>
    </div>
  );
}
